export default "__VITE_ASSET__ZCxPCqrW__"